import { useQuery } from '@apollo/client';
import { UserContext } from '@providers/userContextProvider';
import { useContext, useMemo } from 'react';
import { toAccountAllocationGridReport } from '../accountAllocationGridReport';
import { EDIT_ACCOUNT_ALLOCATIONS_FETCH_PORTFOLIO_REPORTS } from '../editAccountAllocations.queries';

export const useEditAccountAllocations = (
  householdClientGroupId: string | undefined,
) => {
  const { activeOrganization } = useContext(UserContext);
  const organizationId = activeOrganization.id;

  const waitingForOrganization =
    Boolean(householdClientGroupId) && !organizationId;

  const { data, loading, error, refetch } = useQuery(
    EDIT_ACCOUNT_ALLOCATIONS_FETCH_PORTFOLIO_REPORTS,
    {
      variables: {
        input: {
          filter: {
            householdClientGroupId: householdClientGroupId!,
            organizationId,
          },
        },
      },
      skip: !householdClientGroupId || !organizationId,
      fetchPolicy: 'network-only',
    },
  );

  const report = useMemo(
    () =>
      toAccountAllocationGridReport(
        data?.fetchPortfolioReports.portfolioReports[0],
      ),
    [data],
  );

  return {
    report,
    loading: loading || waitingForOrganization,
    error,
    refetch,
  };
};
